var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _path11, _path12, _path13, _path14, _path15, _path16, _rect24, _rect25, _path17, _path18, _path19, _path20, _path21, _rect26, _rect27, _path22, _path23, _path24, _path25, _rect28, _rect29, _path26, _path27, _path28, _path29, _rect30, _rect31, _path30, _path31, _path32, _path33, _rect32, _rect33, _path34, _path35, _path36, _path37, _rect34, _rect35, _path38, _path39, _path40, _path41, _rect36, _rect37, _path42, _path43, _path44, _path45, _rect38, _rect39, _path46, _path47, _path48, _path49, _rect40, _rect41, _path50, _path51, _path52, _path53, _rect42, _rect43, _path54, _path55, _path56, _path57, _rect44, _rect45, _path58, _path59, _path60, _path61, _rect46, _rect47, _path62, _path63, _path64, _path65, _rect48, _rect49, _path66, _path67, _path68, _path69, _rect50, _rect51, _path70, _path71, _path72, _path73, _rect52, _rect53, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeathercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 88,
    viewBox: "0 0 327 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 290.553,
    y: 56.2765,
    width: 8.12579,
    height: 25.6721,
    fill: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290.553 60.9383C290.553 59.1587 291.995 57.716 293.775 57.716C295.555 57.716 296.997 59.1587 296.997 60.9383V81.9486H290.553V60.9383Z",
    fill: "#E6E6E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 287.47,
    y: 54.837,
    width: 3.92279,
    height: 1.43956,
    fill: "#FAFAFA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 297.277,
    y: 54.837,
    width: 3.92279,
    height: 1.43956,
    fill: "#CCCCCC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 291.393,
    y: 54.837,
    width: 5.88419,
    height: 1.43956,
    fill: "#E6E6E6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 284.949,
    y: 46.4396,
    width: 5.32379,
    height: 1.43956,
    fill: "#FAFAFA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 298.678,
    y: 46.4396,
    width: 5.604,
    height: 1.43956,
    fill: "#CCCCCC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 290.272,
    y: 46.4396,
    width: 8.40598,
    height: 1.43956,
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288.591 45H291.673L291.393 46.4396H287.47L288.591 45Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M296.997 45H300.079L301.2 46.4396H297.277L296.997 45Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M291.673 45H296.997L297.277 46.4396H291.393L291.673 45Z",
    fill: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_31_88920",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 286,
    y: 47,
    width: 17,
    height: 8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M286.349 47.8792H302.881L300.079 54.837H289.151L286.349 47.8792Z",
    fill: "#104EA4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_31_88920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.349 47.8792H302.881L300.079 54.837H289.151L286.349 47.8792Z",
    fill: "#104EA4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M293.606 46.4396H295.036L286.098 54.837H284.668L293.606 46.4396Z",
    fill: "#EBF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M296.165 46.4396H298.678L289.703 54.837H287.19L296.165 46.4396Z",
    fill: "#EBF3FF"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M298.118 47.8792H302.881L300.079 54.837H296.997L298.118 47.8792Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M290.833 47.8792H298.118L296.997 54.837H291.953L290.833 47.8792Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0463 67.1488H58.9541C58.9541 67.1488 71.2335 61.8916 98.862 61.8916C126.491 61.8916 138.77 67.1488 138.77 67.1488H178.678V78.9775H19.0463V67.1488Z",
    fill: "#104EA4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M69.6986 64.5201H72.1544L56.8052 78.9774H54.3494L69.6986 64.5201Z",
    fill: "#EBF3FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M125.876 63.4688H128.332L111.755 78.9775H109.299L125.876 63.4688Z",
    fill: "#EBF3FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M77.0662 61.8916H81.364L62.945 78.9775H58.6472L77.0662 61.8916Z",
    fill: "#EBF3FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M128.947 64.5201H133.244L117.895 78.9774H113.597L128.947 64.5201Z",
    fill: "#EBF3FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7392,
    y: 67.1489,
    width: 0.613968,
    height: 11.8287,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8,
    y: 67.1489,
    width: 0.613966,
    height: 11.8287,
    fill: "#D9D9D9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8605,
    y: 67.1489,
    width: 0.613968,
    height: 11.8287,
    fill: "#D9D9D9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 39.9211,
    y: 67.1489,
    width: 0.613968,
    height: 11.8287,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 46.9817,
    y: 67.1489,
    width: 0.613964,
    height: 11.8287,
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0424,
    y: 67.1489,
    width: 0.613968,
    height: 11.8287,
    fill: "#D9D9D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 61.103,
    y: 67.1489,
    width: 0.613968,
    height: 11.8287,
    fill: "#D9D9D9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 71.2335,
    y: 64.5201,
    width: 0.613968,
    height: 14.4573,
    fill: "#D9D9D9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 81.364,
    y: 61.8916,
    width: 0.613968,
    height: 17.0859,
    fill: "#D9D9D9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 0.613968,
    height: 11.8287,
    transform: "matrix(-1 0 0 1 178.985 67.1489)",
    fill: "#D9D9D9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 0.613968,
    height: 11.8287,
    transform: "matrix(-1 0 0 1 171.924 67.1489)",
    fill: "#D9D9D9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 0.613968,
    height: 11.8287,
    transform: "matrix(-1 0 0 1 164.864 67.1489)",
    fill: "#D9D9D9"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 0.613968,
    height: 11.8287,
    transform: "matrix(-1 0 0 1 157.803 67.1489)",
    fill: "#D9D9D9"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 0.613968,
    height: 11.8287,
    transform: "matrix(-1 0 0 1 150.742 67.1489)",
    fill: "#D9D9D9"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 0.613968,
    height: 11.8287,
    transform: "matrix(-1 0 0 1 143.681 67.1489)",
    fill: "#D9D9D9"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 0.613968,
    height: 11.8287,
    transform: "matrix(-1 0 0 1 136.621 67.1489)",
    fill: "#D9D9D9"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 125.877,
    y: 64.5201,
    width: 0.61396,
    height: 14.4573,
    fill: "#D9D9D9"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 116.053,
    y: 61.8916,
    width: 0.613968,
    height: 17.0859,
    fill: "#D9D9D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.8421 79.8211C40.8421 79.882 40.9241 79.9164 40.9626 79.8692C42.077 78.5009 51.6407 68.8044 98.862 68.8044C146.083 68.8044 155.647 78.5009 156.761 79.8692C156.8 79.9164 156.882 79.882 156.882 79.8211C156.882 79.814 156.884 79.8149 156.881 79.8083C156.802 79.5949 150.557 63.2058 98.862 63.2058C47.1671 63.2058 40.922 79.5949 40.8429 79.8083C40.8404 79.8149 40.8421 79.814 40.8421 79.8211Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.627 69.7773H178.678V67.1487H136.446C139.929 68.1947 142.3 69.171 143.627 69.7773ZM61.2779 67.1487H19.0463V69.7773H54.0966C55.4237 69.171 57.7953 68.1947 61.2779 67.1487Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.77 67.1487H178.986C179.494 67.1487 179.906 66.7368 179.906 66.2287C179.906 65.7206 179.494 65.3087 178.986 65.3087H132.722C136.802 66.3093 138.753 67.1419 138.77 67.1487ZM65.0016 65.3087H18.7383C18.2302 65.3087 17.8183 65.7206 17.8183 66.2287C17.8183 66.7368 18.2302 67.1487 18.7383 67.1487H58.954C58.97 67.1419 60.9219 66.3093 65.0016 65.3087Z",
    fill: "#E6E6E6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8421 79.7635C40.8421 79.8232 40.9295 79.8523 40.9582 79.7999C42.0514 77.7997 51.5773 63.3696 98.862 63.3696C146.147 63.3696 155.673 77.7997 156.766 79.7999C156.794 79.8523 156.882 79.8232 156.882 79.7635C156.882 79.7584 156.883 79.7598 156.882 79.7548C156.835 79.5946 150.693 59 98.862 59C47.0306 59 40.8893 79.5947 40.8424 79.7548C40.8409 79.7598 40.8421 79.7584 40.8421 79.7635Z",
    fill: "#E6E6E6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8421 79.7622C40.8421 79.8135 40.921 79.832 40.9415 79.785C41.9518 77.4761 51.3275 59.5462 98.862 59.5462C146.397 59.5462 155.772 77.4761 156.783 79.785C156.803 79.832 156.882 79.8135 156.882 79.7622C156.882 79.7579 156.883 79.7592 156.882 79.7551C156.843 79.6221 150.728 59 98.862 59C46.996 59 40.8812 79.6222 40.8423 79.7551C40.8411 79.7592 40.8421 79.7579 40.8421 79.7622Z",
    fill: "#F2F2F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8421 80.0288C40.8421 80.0288 47.7492 63.2057 98.862 63.2057C149.975 63.2057 156.882 80.0288 156.882 80.0288",
    stroke: "#CCCCCC",
    strokeWidth: 2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6786,
    y: 79.3205,
    width: 174.011,
    height: 3,
    rx: 1.5,
    fill: "#E6E6E6"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    y: 81.614,
    width: 327,
    height: 6,
    fill: "#333333"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 84.114H327",
    stroke: "white",
    strokeLinecap: "round",
    strokeDasharray: "12 12"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M25.1282 76.9588C25.1282 78.6312 23.9991 79.3581 22.6064 79.3581C21.2136 79.3581 20.0846 78.6312 20.0846 76.9588C20.0846 75.2864 21.4938 73.2399 22.6064 73.2399C23.7189 73.2399 25.1282 75.2864 25.1282 76.9588Z",
    fill: "#333333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M25.1282 76.9588C25.1282 78.6312 23.9991 79.3581 22.6064 79.3581C21.2136 79.3581 20.0846 78.6312 20.0846 76.9588C20.0846 75.2864 21.4938 73.2399 22.6064 73.2399C23.7189 73.2399 25.1282 75.2864 25.1282 76.9588Z",
    fill: "#7BCB4B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.848 76.239C24.848 78.1514 22.8783 78.3984 22.6064 78.3984C22.3344 78.3984 20.0846 78.6312 20.0846 76.9588C20.0846 75.2864 21.4938 73.2399 22.6064 73.2399C23.7189 73.2399 24.848 75.0464 24.848 76.239Z",
    fill: "#7BCB4B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3262 76.9991C22.3262 76.8443 22.4517 76.7189 22.6064 76.7189C22.7612 76.7189 22.8866 76.8443 22.8866 76.9991V81.7459C22.8866 81.8847 22.7741 81.9973 22.6353 81.9973H22.5776C22.4388 81.9973 22.3262 81.8847 22.3262 81.7459V76.9991Z",
    fill: "#5B2500"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 0.257332,
    height: 1.85014,
    rx: 0.128666,
    transform: "matrix(0.699909 0.714232 -0.812113 0.583501 23.9682 77.4068)",
    fill: "#5B2500"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 0.257332,
    height: 1.29596,
    rx: 0.128666,
    transform: "matrix(0.69991 -0.714231 0.812113 0.5835 21.4856 77.3825)",
    fill: "#5B2500"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M20.645 78.46C20.645 79.7825 19.6414 80.3573 18.4034 80.3573C17.1654 80.3573 16.1618 79.7825 16.1618 78.46C16.1618 77.1375 17.4145 75.5193 18.4034 75.5193C19.3923 75.5193 20.645 77.1375 20.645 78.46Z",
    fill: "#333333"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M20.645 78.46C20.645 79.7825 19.6414 80.3573 18.4034 80.3573C17.1654 80.3573 16.1618 79.7825 16.1618 78.46C16.1618 77.1375 17.4145 75.5193 18.4034 75.5193C19.3923 75.5193 20.645 77.1375 20.645 78.46Z",
    fill: "#92C354"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3959 77.8908C20.3959 79.4031 18.6451 79.5984 18.4034 79.5984C18.1617 79.5984 16.1618 79.7825 16.1618 78.46C16.1618 77.1375 17.4145 75.5193 18.4034 75.5193C19.3923 75.5193 20.3959 76.9478 20.3959 77.8908Z",
    fill: "#92C354"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1542 78.4475C18.1542 78.3315 18.2483 78.2374 18.3643 78.2374C18.4804 78.2374 18.5745 78.3315 18.5745 78.4475V81.8183C18.5745 81.9171 18.4943 81.9973 18.3954 81.9973H18.3332C18.2343 81.9973 18.1542 81.9171 18.1542 81.8183V78.4475Z",
    fill: "#5B2500"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 0.206813,
    height: 1.54114,
    rx: 0.103406,
    transform: "matrix(0.774115 0.633046 -0.866614 0.498979 19.6138 78.7274)",
    fill: "#5B2500"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 0.206814,
    height: 1.07952,
    rx: 0.103407,
    transform: "matrix(0.774112 -0.633049 0.866612 0.498982 17.4071 78.7102)",
    fill: "#5B2500"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.2801 80.5135C22.2801 81.4647 21.5377 81.8781 20.6219 81.8781C19.7061 81.8781 18.9637 81.4647 18.9637 80.5135C18.9637 79.5623 19.8904 78.3984 20.6219 78.3984C21.3535 78.3984 22.2801 79.5623 22.2801 80.5135Z",
    fill: "#333333"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M22.2801 80.5135C22.2801 81.4647 21.5377 81.8781 20.6219 81.8781C19.7061 81.8781 18.9637 81.4647 18.9637 80.5135C18.9637 79.5623 19.8904 78.3984 20.6219 78.3984C21.3535 78.3984 22.2801 79.5623 22.2801 80.5135Z",
    fill: "#A6DB4E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0958 80.1041C22.0958 81.1918 20.8007 81.3322 20.6219 81.3322C20.4431 81.3322 18.9637 81.4647 18.9637 80.5135C18.9637 79.5623 19.8904 78.3984 20.6219 78.3984C21.3535 78.3984 22.0958 79.4258 22.0958 80.1041Z",
    fill: "#A6DB4E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4528 81.1002C20.4528 81.0228 20.5155 80.9601 20.5929 80.9601C20.6703 80.9601 20.733 81.0228 20.733 81.1002V82.1764C20.733 82.21 20.7058 82.2372 20.6722 82.2372H20.5136C20.48 82.2372 20.4528 82.21 20.4528 82.1764V81.1002Z",
    fill: "#5B2500"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 0.137381,
    height: 1.07925,
    rx: 0.0686904,
    transform: "matrix(0.880622 0.473819 -0.935145 0.354265 21.5336 81.1586)",
    fill: "#5B2500"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 0.13738,
    height: 0.755978,
    rx: 0.06869,
    transform: "matrix(0.880629 -0.473807 0.935149 0.354256 19.8661 81.1501)",
    fill: "#5B2500"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M41.0996 76.9588C41.0996 78.6312 39.9705 79.3581 38.5778 79.3581C37.185 79.3581 36.056 78.6312 36.056 76.9588C36.056 75.2864 37.4652 73.2399 38.5778 73.2399C39.6903 73.2399 41.0996 75.2864 41.0996 76.9588Z",
    fill: "#333333"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M41.0996 76.9588C41.0996 78.6312 39.9705 79.3581 38.5778 79.3581C37.185 79.3581 36.056 78.6312 36.056 76.9588C36.056 75.2864 37.4652 73.2399 38.5778 73.2399C39.6903 73.2399 41.0996 75.2864 41.0996 76.9588Z",
    fill: "#7BCB4B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8194 76.239C40.8194 78.1514 38.8497 78.3984 38.5778 78.3984C38.3058 78.3984 36.056 78.6312 36.056 76.9588C36.056 75.2864 37.4652 73.2399 38.5778 73.2399C39.6903 73.2399 40.8194 75.0464 40.8194 76.239Z",
    fill: "#7BCB4B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2977 76.9991C38.2977 76.8443 38.4231 76.7189 38.5779 76.7189C38.7326 76.7189 38.8581 76.8443 38.8581 76.9991V81.7459C38.8581 81.8847 38.7455 81.9973 38.6067 81.9973H38.549C38.4102 81.9973 38.2977 81.8847 38.2977 81.7459V76.9991Z",
    fill: "#5B2500"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 0.257332,
    height: 1.85014,
    rx: 0.128666,
    transform: "matrix(0.699909 0.714232 -0.812113 0.583501 39.9396 77.4068)",
    fill: "#5B2500"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 0.257332,
    height: 1.29596,
    rx: 0.128666,
    transform: "matrix(0.69991 -0.714231 0.812114 0.583499 37.457 77.3825)",
    fill: "#5B2500"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M36.5665 78.6914C36.5665 79.9923 35.6368 80.5577 34.4899 80.5577C33.3431 80.5577 32.4134 79.9923 32.4134 78.6914C32.4134 77.3904 33.5738 75.7986 34.4899 75.7986C35.4061 75.7986 36.5665 77.3904 36.5665 78.6914Z",
    fill: "#333333"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M36.5665 78.6914C36.5665 79.9923 35.6368 80.5577 34.4899 80.5577C33.3431 80.5577 32.4134 79.9923 32.4134 78.6914C32.4134 77.3904 33.5738 75.7986 34.4899 75.7986C35.4061 75.7986 36.5665 77.3904 36.5665 78.6914Z",
    fill: "#92C354"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3358 78.1315C36.3358 79.619 34.7139 79.8111 34.4899 79.8111C34.266 79.8111 32.4134 79.9923 32.4134 78.6914C32.4134 77.3904 33.5738 75.7986 34.4899 75.7986C35.4061 75.7986 36.3358 77.2038 36.3358 78.1315Z",
    fill: "#92C354"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2902 78.677C34.2902 78.5667 34.3795 78.4774 34.4898 78.4774C34.6 78.4774 34.6894 78.5667 34.6894 78.677V82.0583C34.6894 82.1571 34.6092 82.2373 34.5103 82.2373H34.4692C34.3703 82.2373 34.2902 82.1571 34.2902 82.0583V78.677Z",
    fill: "#5B2500"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 0.183305,
    height: 1.3179,
    rx: 0.0916524,
    transform: "matrix(0.69991 0.714231 -0.812114 0.583499 35.4597 78.9673)",
    fill: "#5B2500"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 0.183306,
    height: 0.923155,
    rx: 0.0916529,
    transform: "matrix(0.699907 -0.714234 0.812112 0.583502 33.6913 78.9501)",
    fill: "#5B2500"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M37.9713 80.5135C37.9713 81.4647 37.2289 81.8781 36.3131 81.8781C35.3974 81.8781 34.655 81.4647 34.655 80.5135C34.655 79.5623 35.5816 78.3984 36.3131 78.3984C37.0447 78.3984 37.9713 79.5623 37.9713 80.5135Z",
    fill: "#333333"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M37.9713 80.5135C37.9713 81.4647 37.2289 81.8781 36.3131 81.8781C35.3974 81.8781 34.655 81.4647 34.655 80.5135C34.655 79.5623 35.5816 78.3984 36.3131 78.3984C37.0447 78.3984 37.9713 79.5623 37.9713 80.5135Z",
    fill: "#A6DB4E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7871 80.1041C37.7871 81.1918 36.492 81.3322 36.3131 81.3322C36.1343 81.3322 34.655 81.4647 34.655 80.5135C34.655 79.5623 35.5816 78.3984 36.3131 78.3984C37.0447 78.3984 37.7871 79.4258 37.7871 80.1041Z",
    fill: "#A6DB4E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1441 81.1621C36.1441 81.0505 36.2346 80.9601 36.3462 80.9601C36.4577 80.9601 36.5482 81.0505 36.5482 81.1621V82.1764C36.5482 82.21 36.521 82.2372 36.4874 82.2372H36.2049C36.1713 82.2372 36.1441 82.21 36.1441 82.1764V81.1621Z",
    fill: "#5B2500"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 0.137381,
    height: 1.07925,
    rx: 0.0686904,
    transform: "matrix(0.880622 0.473819 -0.935145 0.354265 37.2249 81.1586)",
    fill: "#5B2500"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 0.13738,
    height: 0.755976,
    rx: 0.0686899,
    transform: "matrix(0.880628 -0.473808 0.935148 0.354256 35.5573 81.1501)",
    fill: "#5B2500"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M42.4545 80.5135C42.4545 81.4647 41.7121 81.8781 40.7964 81.8781C39.8806 81.8781 39.1382 81.4647 39.1382 80.5135C39.1382 79.5623 40.0648 78.3984 40.7964 78.3984C41.5279 78.3984 42.4545 79.5623 42.4545 80.5135Z",
    fill: "#333333"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M42.4545 80.5135C42.4545 81.4647 41.7121 81.8781 40.7964 81.8781C39.8806 81.8781 39.1382 81.4647 39.1382 80.5135C39.1382 79.5623 40.0648 78.3984 40.7964 78.3984C41.5279 78.3984 42.4545 79.5623 42.4545 80.5135Z",
    fill: "#A6DB4E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2703 80.1041C42.2703 81.1918 40.9752 81.3322 40.7964 81.3322C40.6175 81.3322 39.1382 81.4647 39.1382 80.5135C39.1382 79.5623 40.0648 78.3984 40.7964 78.3984C41.5279 78.3984 42.2703 79.4258 42.2703 80.1041Z",
    fill: "#A6DB4E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6273 81.1621C40.6273 81.0505 40.7177 80.9601 40.8293 80.9601C40.9409 80.9601 41.0314 81.0505 41.0314 81.1621V82.1764C41.0314 82.21 41.0041 82.2372 40.9705 82.2372H40.6881C40.6545 82.2372 40.6273 82.21 40.6273 82.1764V81.1621Z",
    fill: "#5B2500"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 0.137381,
    height: 1.07925,
    rx: 0.0686904,
    transform: "matrix(0.880622 0.473819 -0.935145 0.354265 41.7082 81.1586)",
    fill: "#5B2500"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 0.13738,
    height: 0.755976,
    rx: 0.0686899,
    transform: "matrix(0.880628 -0.473808 0.935148 0.354256 40.0405 81.1501)",
    fill: "#5B2500"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M148.136 76.9588C148.136 78.6312 147.007 79.3581 145.614 79.3581C144.221 79.3581 143.092 78.6312 143.092 76.9588C143.092 75.2864 144.502 73.2399 145.614 73.2399C146.727 73.2399 148.136 75.2864 148.136 76.9588Z",
    fill: "#333333"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M148.136 76.9588C148.136 78.6312 147.007 79.3581 145.614 79.3581C144.221 79.3581 143.092 78.6312 143.092 76.9588C143.092 75.2864 144.502 73.2399 145.614 73.2399C146.727 73.2399 148.136 75.2864 148.136 76.9588Z",
    fill: "#7BCB4B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M147.856 76.239C147.856 78.1514 145.886 78.3984 145.614 78.3984C145.342 78.3984 143.092 78.6312 143.092 76.9588C143.092 75.2864 144.502 73.2399 145.614 73.2399C146.727 73.2399 147.856 75.0464 147.856 76.239Z",
    fill: "#7BCB4B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M145.334 76.9991C145.334 76.8443 145.459 76.7189 145.614 76.7189C145.769 76.7189 145.894 76.8443 145.894 76.9991V81.7459C145.894 81.8847 145.782 81.9973 145.643 81.9973H145.585C145.446 81.9973 145.334 81.8847 145.334 81.7459V76.9991Z",
    fill: "#5B2500"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 0.257333,
    height: 1.85014,
    rx: 0.128666,
    transform: "matrix(0.699909 0.714232 -0.812113 0.5835 146.976 77.4068)",
    fill: "#5B2500"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 0.257331,
    height: 1.29596,
    rx: 0.128666,
    transform: "matrix(0.699909 -0.714232 0.812113 0.5835 144.493 77.3825)",
    fill: "#5B2500"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M143.653 78.46C143.653 79.7825 142.649 80.3573 141.411 80.3573C140.173 80.3573 139.17 79.7825 139.17 78.46C139.17 77.1375 140.422 75.5193 141.411 75.5193C142.4 75.5193 143.653 77.1375 143.653 78.46Z",
    fill: "#333333"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M143.653 78.46C143.653 79.7825 142.649 80.3573 141.411 80.3573C140.173 80.3573 139.17 79.7825 139.17 78.46C139.17 77.1375 140.422 75.5193 141.411 75.5193C142.4 75.5193 143.653 77.1375 143.653 78.46Z",
    fill: "#92C354"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M143.404 77.8908C143.404 79.4031 141.653 79.5984 141.411 79.5984C141.169 79.5984 139.17 79.7825 139.17 78.46C139.17 77.1375 140.422 75.5193 141.411 75.5193C142.4 75.5193 143.404 76.9478 143.404 77.8908Z",
    fill: "#92C354"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M141.162 78.4475C141.162 78.3315 141.256 78.2374 141.372 78.2374C141.488 78.2374 141.582 78.3315 141.582 78.4475V81.8183C141.582 81.9171 141.502 81.9973 141.403 81.9973H141.341C141.242 81.9973 141.162 81.9171 141.162 81.8183V78.4475Z",
    fill: "#5B2500"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 0.206813,
    height: 1.54114,
    rx: 0.103406,
    transform: "matrix(0.774114 0.633046 -0.866614 0.49898 142.622 78.7274)",
    fill: "#5B2500"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 0.206814,
    height: 1.07952,
    rx: 0.103407,
    transform: "matrix(0.774112 -0.633048 0.866613 0.498982 140.415 78.7102)",
    fill: "#5B2500"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M145.288 80.5135C145.288 81.4647 144.545 81.8781 143.63 81.8781C142.714 81.8781 141.971 81.4647 141.971 80.5135C141.971 79.5623 142.898 78.3984 143.63 78.3984C144.361 78.3984 145.288 79.5623 145.288 80.5135Z",
    fill: "#333333"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M145.288 80.5135C145.288 81.4647 144.545 81.8781 143.63 81.8781C142.714 81.8781 141.971 81.4647 141.971 80.5135C141.971 79.5623 142.898 78.3984 143.63 78.3984C144.361 78.3984 145.288 79.5623 145.288 80.5135Z",
    fill: "#A6DB4E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M145.104 80.1041C145.104 81.1918 143.808 81.3322 143.63 81.3322C143.451 81.3322 141.971 81.4647 141.971 80.5135C141.971 79.5623 142.898 78.3984 143.63 78.3984C144.361 78.3984 145.104 79.4258 145.104 80.1041Z",
    fill: "#A6DB4E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M143.461 81.1002C143.461 81.0228 143.523 80.9601 143.601 80.9601C143.678 80.9601 143.741 81.0228 143.741 81.1002V82.1764C143.741 82.21 143.714 82.2372 143.68 82.2372H143.522C143.488 82.2372 143.461 82.21 143.461 82.1764V81.1002Z",
    fill: "#5B2500"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 0.137381,
    height: 1.07925,
    rx: 0.0686904,
    transform: "matrix(0.880622 0.473819 -0.935145 0.354265 144.541 81.1586)",
    fill: "#5B2500"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 0.137381,
    height: 0.755985,
    rx: 0.0686906,
    transform: "matrix(0.880631 -0.473803 0.93515 0.354252 142.874 81.1501)",
    fill: "#5B2500"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M166.629 76.7189C166.629 78.3913 165.5 79.1181 164.107 79.1181C162.715 79.1181 161.586 78.3913 161.586 76.7189C161.586 75.0464 162.995 73 164.107 73C165.22 73 166.629 75.0464 166.629 76.7189Z",
    fill: "#333333"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M166.629 76.7189C166.629 78.3913 165.5 79.1181 164.107 79.1181C162.715 79.1181 161.586 78.3913 161.586 76.7189C161.586 75.0464 162.995 73 164.107 73C165.22 73 166.629 75.0464 166.629 76.7189Z",
    fill: "#7BCB4B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M166.349 75.9991C166.349 77.9114 164.379 78.1584 164.107 78.1584C163.835 78.1584 161.586 78.3913 161.586 76.7189C161.586 75.0464 162.995 73 164.107 73C165.22 73 166.349 74.8065 166.349 75.9991Z",
    fill: "#7BCB4B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M163.827 76.7591C163.827 76.6043 163.953 76.4789 164.107 76.4789C164.262 76.4789 164.388 76.6043 164.388 76.7591V81.5059C164.388 81.6447 164.275 81.7573 164.136 81.7573H164.079C163.94 81.7573 163.827 81.6447 163.827 81.5059V76.7591Z",
    fill: "#5B2500"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 0.257333,
    height: 1.85014,
    rx: 0.128666,
    transform: "matrix(0.699909 0.714232 -0.812113 0.5835 165.469 77.1668)",
    fill: "#5B2500"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 0.257331,
    height: 1.29596,
    rx: 0.128666,
    transform: "matrix(0.699909 -0.714232 0.812113 0.5835 162.987 77.1425)",
    fill: "#5B2500"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M162.096 78.4514C162.096 79.7524 161.166 80.3177 160.019 80.3177C158.873 80.3177 157.943 79.7524 157.943 78.4514C157.943 77.1505 159.103 75.5587 160.019 75.5587C160.936 75.5587 162.096 77.1505 162.096 78.4514Z",
    fill: "#333333"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M162.096 78.4514C162.096 79.7524 161.166 80.3177 160.019 80.3177C158.873 80.3177 157.943 79.7524 157.943 78.4514C157.943 77.1505 159.103 75.5587 160.019 75.5587C160.936 75.5587 162.096 77.1505 162.096 78.4514Z",
    fill: "#92C354"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M161.865 77.8915C161.865 79.3791 160.243 79.5712 160.019 79.5712C159.795 79.5712 157.943 79.7524 157.943 78.4514C157.943 77.1505 159.103 75.5587 160.019 75.5587C160.936 75.5587 161.865 76.9639 161.865 77.8915Z",
    fill: "#92C354"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M159.82 78.437C159.82 78.3268 159.909 78.2374 160.019 78.2374C160.13 78.2374 160.219 78.3268 160.219 78.437V81.8183C160.219 81.9172 160.139 81.9974 160.04 81.9974H159.999C159.9 81.9974 159.82 81.9172 159.82 81.8183V78.437Z",
    fill: "#5B2500"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 0.183304,
    height: 1.3179,
    rx: 0.0916521,
    transform: "matrix(0.699908 0.714233 -0.812112 0.583501 160.989 78.7274)",
    fill: "#5B2500"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 0.183303,
    height: 0.92314,
    rx: 0.0916513,
    transform: "matrix(0.699911 -0.71423 0.812114 0.583498 159.221 78.7103)",
    fill: "#5B2500"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M163.501 80.2736C163.501 81.2248 162.759 81.6382 161.843 81.6382C160.927 81.6382 160.185 81.2248 160.185 80.2736C160.185 79.3224 161.111 78.1584 161.843 78.1584C162.574 78.1584 163.501 79.3224 163.501 80.2736Z",
    fill: "#333333"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M163.501 80.2736C163.501 81.2248 162.759 81.6382 161.843 81.6382C160.927 81.6382 160.185 81.2248 160.185 80.2736C160.185 79.3224 161.111 78.1584 161.843 78.1584C162.574 78.1584 163.501 79.3224 163.501 80.2736Z",
    fill: "#A6DB4E"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M163.317 79.8642C163.317 80.9518 162.022 81.0923 161.843 81.0923C161.664 81.0923 160.185 81.2248 160.185 80.2736C160.185 79.3224 161.111 78.1584 161.843 78.1584C162.574 78.1584 163.317 79.1859 163.317 79.8642Z",
    fill: "#A6DB4E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M161.674 80.9223C161.674 80.8107 161.764 80.7203 161.876 80.7203C161.987 80.7203 162.078 80.8107 162.078 80.9223V81.9366C162.078 81.9702 162.051 81.9974 162.017 81.9974H161.734C161.701 81.9974 161.674 81.9702 161.674 81.9366V80.9223Z",
    fill: "#5B2500"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 0.137381,
    height: 1.07925,
    rx: 0.0686904,
    transform: "matrix(0.880622 0.473819 -0.935145 0.354265 162.754 80.9189)",
    fill: "#5B2500"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 0.137381,
    height: 0.755978,
    rx: 0.0686903,
    transform: "matrix(0.880618 -0.473827 0.935142 0.354272 161.087 80.9105)",
    fill: "#5B2500"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M167.984 80.2736C167.984 81.2248 167.242 81.6382 166.326 81.6382C165.41 81.6382 164.668 81.2248 164.668 80.2736C164.668 79.3224 165.594 78.1584 166.326 78.1584C167.058 78.1584 167.984 79.3224 167.984 80.2736Z",
    fill: "#333333"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M167.984 80.2736C167.984 81.2248 167.242 81.6382 166.326 81.6382C165.41 81.6382 164.668 81.2248 164.668 80.2736C164.668 79.3224 165.594 78.1584 166.326 78.1584C167.058 78.1584 167.984 79.3224 167.984 80.2736Z",
    fill: "#A6DB4E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M167.8 79.8642C167.8 80.9518 166.505 81.0923 166.326 81.0923C166.147 81.0923 164.668 81.2248 164.668 80.2736C164.668 79.3224 165.594 78.1584 166.326 78.1584C167.057 78.1584 167.8 79.1859 167.8 79.8642Z",
    fill: "#A6DB4E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M166.157 80.9223C166.157 80.8107 166.247 80.7203 166.359 80.7203C166.471 80.7203 166.561 80.8107 166.561 80.9223V81.9366C166.561 81.9702 166.534 81.9974 166.5 81.9974H166.218C166.184 81.9974 166.157 81.9702 166.157 81.9366V80.9223Z",
    fill: "#5B2500"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 0.137381,
    height: 1.07925,
    rx: 0.0686904,
    transform: "matrix(0.880622 0.473819 -0.935145 0.354265 167.238 80.9189)",
    fill: "#5B2500"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 0.137383,
    height: 0.75599,
    rx: 0.0686913,
    transform: "matrix(0.880622 -0.47382 0.935145 0.354266 165.57 80.9105)",
    fill: "#5B2500"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M277.871 20.4544C279.324 20.7769 281.066 22.3046 281.066 22.3046C281.066 22.3046 282.932 19.5299 284.972 18.9897C286.956 18.4643 289.854 19.9919 289.854 19.9919C289.854 19.9919 291.895 15.6168 295.801 17.4479C297.455 18.2235 297.665 21.3024 297.665 21.3024C297.665 21.3024 302.308 18.3615 304.055 19.9919C305.425 21.2701 304.055 24.4631 304.055 24.4631C304.055 24.4631 307.646 25.4487 308.227 26.6987C309.063 28.4977 303.611 29.3198 303.611 29.3198C303.611 29.3198 297.757 30.3715 294.025 29.8594C292.016 29.5836 288.966 28.7801 288.966 28.7801C288.966 28.7801 284.951 29.7529 282.309 29.8594C279.666 29.9659 278.094 29.9884 275.563 29.3198C273.16 28.6848 270.458 28.8225 269.882 26.6987C269.481 25.216 270.262 24.2246 271.303 22.9984C272.969 21.0347 275.15 19.8505 277.871 20.4544Z",
    fill: "url(#paint0_linear_31_88920)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M280.387 29.95C280.387 29.95 279.913 26.5839 283.782 27.043C285.083 27.1973 286.309 29.0779 286.309 29.0779C286.309 29.0779 289.302 26.5316 291.126 27.3337C292.607 27.9852 293.295 29.2493 293.1 30.7495C292.868 32.5283 291.145 33.1325 289.309 33.7291C287.269 34.3924 283.782 33.3658 283.782 33.3658C283.782 33.3658 280.248 34.5056 278.255 33.7291C276.609 33.0876 275.389 32.0868 275.649 30.4587C275.959 28.5246 280.387 29.95 280.387 29.95Z",
    fill: "url(#paint1_linear_31_88920)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M113.383 15.95C113.383 15.95 112.91 12.5839 116.779 13.043C118.079 13.1973 119.305 15.0779 119.305 15.0779C119.305 15.0779 122.298 12.5316 124.122 13.3337C125.603 13.9852 126.292 15.2493 126.096 16.7495C125.864 18.5283 124.141 19.1325 122.306 19.7291C120.265 20.3924 116.779 19.3658 116.779 19.3658C116.779 19.3658 113.244 20.5056 111.251 19.7291C109.605 19.0876 108.386 18.0868 108.646 16.4587C108.955 14.5246 113.383 15.95 113.383 15.95Z",
    fill: "url(#paint2_linear_31_88920)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M186.193 17.8138L233.815 10.6237C233.815 10.6237 261.255 6.4171 273.519 6.10682C280.933 5.91925 284.097 9.23931 284.129 10.1663C284.193 12.0191 278.452 14.7211 273.846 15.5974C260.216 18.1905 235.412 21.3872 235.412 21.3872C235.412 21.3872 215.138 25.039 201.198 23.7248C196.053 23.2397 187.529 22.5211 186.281 21.7674C184.152 20.2491 184.181 18.2485 186.193 17.8138Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M186.193 20.6115C186.193 20.6115 198.638 22.9173 222.706 20.4156C238.234 18.8016 246.991 17.5918 262.41 15.3392C278.36 13.0091 284.129 10.1663 284.129 10.1663C284.193 12.0192 278.451 14.7212 273.846 15.5974C260.216 18.1906 235.412 21.3872 235.412 21.3872C235.412 21.3872 215.138 25.0391 201.198 23.7248C196.052 23.2397 187.366 22.5211 186.281 21.7674C185.732 21.5419 184.262 20.0032 186.193 20.6115Z",
    fill: "#CCCCCC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M210.081 17.8114C222.571 16.3711 235.652 14.594 246.992 13.0703M268.713 10.3046C263.722 10.8482 257.129 11.7118 249.655 12.7128",
    stroke: "#808080",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M275.909 8.39283C278.85 8.11306 280.483 7.69354 280.712 7.27381",
    stroke: "#333333",
    strokeWidth: 4,
    strokeDasharray: "6 1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M181.823 3.72189C181.796 2.9709 184.433 2.2657 186.398 2.61852C188.363 2.97133 201.058 15.086 204.525 15.1971L188.05 17.6845C186.717 11.8285 181.892 5.69547 181.823 3.72189Z",
    fill: "#B2271F"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M182.15 4.28116C182.123 3.53017 184.106 2.82497 186.071 3.17779C188.036 3.5306 200.078 15.0857 204.525 15.1968L188.05 17.6843C186.717 11.8282 182.545 6.53452 182.15 4.28116Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M211.479 16.9028C211.526 16.8941 211.574 16.889 211.623 16.8875L236.44 16.1455C237.649 16.1093 237.89 17.8512 236.713 18.1194L227.98 20.1082C227.881 20.1309 227.778 20.1381 227.676 20.1297L211.593 18.7965C210.478 18.7041 210.382 17.1045 211.479 16.9028Z",
    fill: "#B2271F"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.567 17.3072L233.892 16.9179C235.112 16.8966 235.319 18.662 234.124 18.8981L227.965 20.1152C227.875 20.133 227.783 20.1383 227.692 20.1309L211.612 18.8392C210.684 18.7646 210.644 17.4163 211.567 17.3072Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M182.421 17.6467C182.474 17.6327 182.529 17.6263 182.584 17.6277L185.493 17.7023C186.594 17.7306 186.738 19.311 185.661 19.5379C185.517 19.5682 185.368 19.5639 185.226 19.5253L182.418 18.7615C181.848 18.6066 181.851 17.7976 182.421 17.6467Z",
    fill: "#B2271F"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M182.3 17.9108C182.325 17.9071 182.351 17.9055 182.376 17.906L185.314 17.9671C186.265 17.9869 186.39 19.3555 185.458 19.5469C185.34 19.5712 185.218 19.5684 185.101 19.5387L182.253 18.815C181.764 18.6907 181.8 17.9841 182.3 17.9108Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M229.187 19.3153C229.187 19.3153 231.804 17.019 234.469 16.6075C237.337 16.1647 241.875 15.8185 241.875 15.8185L242.896 20.7778C242.896 20.7778 238.808 21.7149 236.144 22.1264C233.276 22.5692 229.84 21.6934 229.84 21.6934C229.84 21.6934 227.901 20.9966 227.901 20.7155C227.901 20.4344 229.187 19.3153 229.187 19.3153Z",
    fill: "#333333"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M229.073 19.3326C229.073 19.3326 231.465 17.0701 233.93 16.6888C236.584 16.2784 240.786 15.9828 240.786 15.9828L241.807 20.9421C241.807 20.9421 238.031 21.8323 235.566 22.2136C232.913 22.624 229.714 21.7125 229.714 21.7125C229.714 21.7125 227.905 20.996 227.901 20.7155C227.897 20.4351 229.073 19.3326 229.073 19.3326Z",
    fill: "#CCCCCC"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M229.073 19.3326C229.073 19.3326 231.465 17.0701 233.93 16.6888C236.584 16.2784 240.786 15.9828 240.786 15.9828L241.807 20.9421C241.807 20.9421 238.031 21.8323 235.566 22.2136C232.913 22.624 229.714 21.7125 229.714 21.7125C229.714 21.7125 227.905 20.996 227.901 20.7155C227.897 20.4351 229.073 19.3326 229.073 19.3326Z",
    fill: "url(#paint3_radial_31_88920)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M229.402 19.1588C229.402 19.1588 231.732 17.1656 234.095 16.8009C236.638 16.4084 240.661 16.0937 240.661 16.0937L241.542 20.3756C241.542 20.3756 237.916 21.1993 235.553 21.564C233.009 21.9565 229.969 21.2115 229.969 21.2115C229.969 21.2115 228.254 20.6161 228.255 20.3732C228.257 20.1303 229.402 19.1588 229.402 19.1588Z",
    fill: "#FAFAFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_88920",
    x1: 289.045,
    y1: 17,
    x2: 289.045,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31_88920",
    x1: 284.373,
    y1: 27,
    x2: 284.373,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_31_88920",
    x1: 117.37,
    y1: 13,
    x2: 117.37,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_31_88920",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(232.454 9.24372) rotate(78.4058) scale(21.134 50.2066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.493138,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526746,
    stopColor: "#860000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeathercard);
export default __webpack_public_path__ + "static/media/weathercard.e4f16c4b8760ec14ede1e0e315032afc.svg";
export { ForwardRef as ReactComponent };